var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75625 9.73767L10.1375 13.9877H14.6062L10.9937 16.6189L12.375 20.8689L8.75625 18.2439L5.1375 20.8689L6.525 16.6189L2.90625 13.9877H7.375L8.75625 9.73767Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9688 24.7813L17.9126 23.4813L16.3501 24.0876L17.2563 22.6813L16.2001 21.3751L17.8188 21.8063L18.7313 20.4001L18.8188 22.0751L20.4438 22.5063L18.8751 23.1063L18.9688 24.7813Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0688 20.9688L21.5688 19.3688L20.2001 18.4001L21.8751 18.3751L22.3688 16.7751L22.9126 18.3626L24.5876 18.3438L23.2438 19.3438L23.7813 20.9313L22.4126 19.9626L21.0688 20.9688Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 11.744L23.1624 13.2503L24.3624 14.419L22.7062 14.1815L21.9687 15.6815L21.6812 14.0315L20.0187 13.794L21.5062 13.0128L21.2187 11.3565L22.4187 12.5253L23.8999 11.744Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0126 7.18134L18.8876 8.85009L20.4439 9.48134L18.8126 9.88134L18.6939 11.5563L17.8126 10.1313L16.1814 10.5313L17.2626 9.25009L16.3751 7.83134L17.9314 8.46259L19.0126 7.18134Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.81429979.svg";
export { ForwardRef as ReactComponent };